import React, { useEffect, useState } from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Box,
    Stack,
    Typography,
    IconButton,
    CircularProgress,
    Tooltip,
} from "@mui/material";
import BlockIcon from '@mui/icons-material/Block';

import moment from "moment";
import PaymentSummary from "./ItemCard";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { callActiveInactiveCron, checkPrivileges } from "../../Helpers";
import ConfirmDialoag from "../common/ConfirmDialoag";
import instance from "../../axios";

const ListItemsInvoicebase = ({ open, onClose, selectedPaymentItem, getInvoices }) => {
    const [visibleCount, setVisibleCount] = useState(6);
    const [selectedPaymentId, setSelectedPaymentId] = useState(null);


    const handleLoadMore = () => {
        setVisibleCount((prev) => prev + 3);
    };
    const [invoicePayments, setInvoicePayments] = useState([]);
    const [loading, setLoading] = useState(false);
    const [isAllocatedConfirm, setIsAllocatedConfirm] = useState(false);


    const fetchInvoicePayments = async () => {
        if (!selectedPaymentItem) return;
        setLoading(true);
        try {
            const data = await instance.get(
                `api/manualinvoices/items/${selectedPaymentItem.id}`
            );
            setInvoicePayments(data || []);
        } catch (error) {
            console.error("Error fetching invoice payments:", error);
            toast.error("Failed to load payments");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchInvoicePayments();
    }, [selectedPaymentItem]);

    const showSelectedPayment = (item) => {
        setSelectedPaymentId(item)
        setIsAllocatedConfirm(true)

    }


    const updateInvoicePayment = async () => {
        if (!selectedPaymentId) return;
        try {
            const data = await instance.put(
                `/api/invoicepayments/processpiip/${selectedPaymentId.id}`
            );
            const cn = selectedPaymentId?.contractNumber;
            if (cn && typeof cn === "string" && cn.trim() !== "") {
                callActiveInactiveCron(cn);
            }
            fetchInvoicePayments();
            getInvoices()
            onClose()
            toast.success(data || " Processed Successfully")
        } catch (error) {
            toast.error(error?.message || "Something went wrong")
        } finally {
            handleAllcatedConfrmCancel()
        }
    };
    const handleAllcatedConfrmCancel = () => {
        setIsAllocatedConfirm(false)
    }

    const approveInvoiceItems = async () => {
        if (!selectedPaymentItem) return;
        setLoading(true);
        try {
            const data = await instance.put(
                `/api/manualinvoices/issueinvoice/${selectedPaymentItem.id}?zerovat=${selectedPaymentItem?.attributes?.zeroVat||false}`
            );
            fetchInvoicePayments();
            getInvoices()
            onClose()
            toast.success("Invoice Generate Successfully");

        } catch (error) {
            console.error("Error issueinvoice invoice:", error);
            toast.error("Failed to issueinvoice invoice");
        } finally {
            setLoading(false);
        }
    };
    console.log("selected", selectedPaymentItem)
    return (
        <>
            <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
                <DialogTitle>Invoice No: {selectedPaymentItem?.refNum || ""}</DialogTitle>
                <PaymentSummary saleTotal={selectedPaymentItem?.saleTotal || 0} saleVat={selectedPaymentItem?.saleVat || 0} saleNet={selectedPaymentItem?.saleNet || 0} />
                <Typography variant="h6" sx={{ px: 3, py: 2 }}>
                    List Of Items
                </Typography>
                <Box
                    sx={{
                        display: "flex",
                        px: 3,
                        py: 1,
                        fontWeight: "bold",
                        borderBottom: "2px solid #ddd",
                        backgroundColor: "#fafafa",
                    }}
                >
                    <Box sx={{ width: "25%" }}>Item</Box>
                    <Box sx={{ width: "15%" }}>Sale Total</Box>
                    <Box sx={{ width: "15%" }}>Sale Vat</Box>
                    <Box sx={{ width: "15%" }}>Sale Net</Box>
                    <Box sx={{ width: "15%" }}>Category</Box>
                    <Box sx={{ width: "15%" }}>Expense Type</Box>
                </Box>
                <DialogContent dividers sx={{ maxHeight: 400, overflowY: "auto", p: 0 }}>
                    {loading ? <div
                        style={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            height: '100%',
                            width: '100%',
                            margin: "10px 0px"
                        }}
                    >
                        <CircularProgress color="success" />
                    </div> :
                        <>
                            {invoicePayments.length > 0 ? (
                                <>
                                    {invoicePayments.slice(0, visibleCount).map((item, index) => (
                                        <Stack
                                            key={item.id || index}
                                            direction="row"
                                            spacing={2}
                                            sx={{
                                                px: 3,
                                                py: 1,
                                                "&:hover": { backgroundColor: "#f5f5f5" },
                                                borderBottom: "1px solid #eee",
                                            }}
                                        >
                                           <Box sx={{ width: "25%" }}>
  {item?.itemName || "-"}
  {item?.itemCode ? ` - ${item.itemCode}` : ""}
</Box>
                                            <Box sx={{ width: "15%" }}>{item?.saleTotal?.toFixed(2) || 0}</Box>
                                            <Box sx={{ width: "15%" }}>{item?.saleVat?.toFixed(2) || 0}</Box>
                                            <Box sx={{ width: "15%" }}>{item?.saleNet?.toFixed(2) || 0}</Box>
                                            <Box sx={{ width: "15%" }}>{item?.category || "-"}</Box>
                                            <Box sx={{ width: "15%" }}>{item?.expenseType || "-"}</Box>
                                        </Stack>
                                    ))}
                                    {visibleCount < invoicePayments.length && (
                                        <Box sx={{ textAlign: "center", py: 2 }}>
                                            <Button
                                                variant="outlined"
                                                onClick={handleLoadMore}
                                                size="small"
                                            >
                                                Load More
                                            </Button>
                                        </Box>
                                    )}
                                </>
                            ) : (
                                <Typography
                                    variant="body2"
                                    color="text.secondary"
                                    sx={{ p: 2, textAlign: "center" }}
                                >
                                    No payment details available.
                                </Typography>
                            )}
                        </>
                    }
                </DialogContent>

                <DialogActions>
                    <Button onClick={onClose}>Close</Button>
                    <Button onClick={approveInvoiceItems}     disabled={
        selectedPaymentItem?.issueInvoice ||
        !checkPrivileges("manualInvoiceIssueInvoice")
    }>Approve</Button>
                    

                </DialogActions>
            </Dialog>

            {isAllocatedConfirm && (
                <ConfirmDialoag
                    onCancel={handleAllcatedConfrmCancel}
                    onOk={updateInvoicePayment}
                    title={"Are You Sure?"}
                    children={selectedPaymentId?.contractNumber?.toUpperCase()}
                />
            )}
        </>

    );
};

export default ListItemsInvoicebase;
